import { default as evaluation } from ":src/modules/grading/evaluation/routes";
import { default as faq_inquiry } from ":src/modules/help-portal/faq-inquiry/routes";
import { default as profile } from ":src/modules/account/profile/routes";
export default {
  BASE: "/evaluator",
  evaluation,
  faq_inquiry,
  profile,
};
